namespace $ { export class $piterjs_image extends $mol_image2 {

	/**
	 *  ```
	 *  links /
	 *  	<= link
	 *  	\piterjs/logo/logo.svg
	 *  ```
	 **/
	links() {
		return [this.link() , "piterjs/logo/logo.svg"] as readonly any[]
	}

	/**
	 *  ```
	 *  link \
	 *  ```
	 **/
	link() {
		return ""
	}

} }
